// import React from 'react';
import './App.css';
import Routes from '@/routes/index'
function App() {
  return (
    <div>
      <Routes></Routes>
    </div>
  );
}

export default App;
